import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { ConsultorioHorarioRequest, ConsultorioHorariosInsertRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-horario.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class ConsultorioHorarioService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.consultorioPrivado.horarioConsulta;
    readonly PATH_INSERIR = SICOM_PATHS.registro.medico.consultorioPrivado.horario;

    buscar(params: Pessoa & { idConsultorio: number }, context?: HttpContext): Observable<ConsultorioHorarioRequest[]> {
        const httpParams = new HttpParams().set('id', params.id).set('uf', params.uf).set('idConsultorio', params.idConsultorio);
        return this.http.get<ConsultorioHorarioRequest[]>(this.PATH, { params: httpParams, context });
    }

    inserirHorarios(pessoa: Pessoa, body: ConsultorioHorariosInsertRequest, context?: HttpContext): Observable<void> {
        const httpParams = new HttpParams().set('id', pessoa.id).set('uf', pessoa.uf);
        return this.http.post<void>(this.PATH_INSERIR, body, { params: httpParams, context });
    }
}
